import {useLocation, matchPath} from 'react-router'

import {plantRoutes} from '../common/routing'

export const usePlantUpmIdFromRoute = (): string | undefined => {
  const {pathname} = useLocation()
  let plantId
  for (const path of plantRoutes) {
    const match = matchPath({path}, pathname)
    if (match?.params) {
      plantId = match.params?.plantId
    }
  }
  return plantId
}
